import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Box from 'common/components/Box';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';
import Image from 'common/components/Image';
import Container from 'common/components/UI/Container';
import ProcessItem, { ProcessIndex } from './workingProcess.style';
import style from './workingprocess.css';
const WorriesSection = ({
  sectionWrapper,
  secTitleWrapper,
  secText,
  secHeading,
  processRow,
  processCol,
  processImageStyle,
  processDescriptionStyle,
  processImageWrapperStyle,
}) => {
  const Data = useStaticQuery(graphql`
    query {
      saasModernJson {
        PROCESS_ITEMS {
          title
          description
          image {
            publicURL
          }
        }
      }
    }
  `);

  return (
    <Box {...sectionWrapper} as='section'>
      <Container>
        <Box {...secTitleWrapper}>
          <Heading {...secHeading} content='スピード導入' />
          <Text
            content='たったの3ステップで簡単に導入できます'
            {...secText}
          ></Text>
        </Box>

        <Box {...processRow}>
          {Data.saasModernJson.PROCESS_ITEMS.map((item, index) => (
            <Box
              {...processCol}
              key={`process-item-${index}`}
              className='process_item_col'
            >
              <ProcessItem className='process_item'>
                <Box {...processImageWrapperStyle}>
                  <Image
                    src={item.image.publicURL}
                    alt={`process-image-${index + 1}`}
                    {...processImageStyle}
                    style={{ margin: '0 auto', zIndex: 100 }}
                  />
                </Box>
                <div style={{ textAlign: 'center' }}>
                  <h2 className={'working_item_heading'}>
                    <span>{index + 1}</span>
                    {item.title}
                  </h2>
                </div>

                <Text content={item.description} {...processDescriptionStyle} />
              </ProcessItem>
            </Box>
          ))}
        </Box>
        {/* <div class='btn_wrapper'>
          {' '}
          <a href='/working' class='btn bgskew'>
            <span>詳しく見る</span>
          </a>
        </div> */}
      </Container>
    </Box>
  );
};

WorriesSection.propTypes = {
  sectionWrapper: PropTypes.object,
  secTitleWrapper: PropTypes.object,
  secTitle: PropTypes.object,
  secDescription: PropTypes.object,
  processRow: PropTypes.object,
  processCol: PropTypes.object,
  processImageStyle: PropTypes.object,
  processTitleStyle: PropTypes.object,
  processDescriptionStyle: PropTypes.object,
  processImageWrapperStyle: PropTypes.object,
};

WorriesSection.defaultProps = {
  sectionWrapper: {
    pt: ['60px', '15px', '15px', '15px', '15px'],
    pb: 0,
    zIndex: 1,
    backgroundColor: '#fff',

    height: ['150vh', '100vh', '120vh', '120vh', '120vh'],
  },
  secTitleWrapper: {
    mb: ['60px', '100px'],
  },
  secText: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '20px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: '#696969',
    mb: '5px',
  },
  secHeading: {
    textAlign: 'center',
    fontSize: ['20px', '48px'],
    fontWeight: '700',
    color: 'primary',
    letterSpacing: '-0.025em',
    mb: '0',
    lineHeight: '1.67',
  },
  processRow: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: ['0', '-15px', '-20px', '-35px', '-45px'],
    mr: ['0', '-15px', '-20px', '-35px', '-45px'],
  },
  processCol: {
    width: [1, 1 / 3],
    pl: ['0', '15px', '20px', '35px', '45px'],
    pr: ['0', '15px', '20px', '35px', '45px'],
    mb: '40px',
  },
  processImageStyle: {
    height: ['100px', '100px', '70px', '200px'],
    width: ['100px', '100px', '70px', '200px'],
    display: 'block',
  },
  processImageWrapperStyle: {
    textAlign: 'center',
  },
  processTitleStyle: {
    fontSize: ['20px', '18px', '20px', '20px', '20px'],
    fontWeight: '400',
    color: '#0f2137',
    letterSpacing: '-0.02em',
    mb: ['20px', '20px', '22px', '22px', '22px'],
    mt: '35px',
  },
  processDescriptionStyle: {
    fontSize: ['15px', '15px', '15px', '18px'],
    textAlign: 'left',
    fontWeight: '700',
    color: '#696969',
    letterSpacing: '-0.025em',
    lineHeight: '1.88',
    mb: 0,
  },
};

export default WorriesSection;
